<template>
	<div class="announcement_vue">
		<div v-loading="loading" id="announcement" v-if="page=='list'">
			<div class="guide material" style="margin-top: 30px;">
                <div v-if="guideList.length!=0">
                    <div class="trends_list">
        		        <div class="trends_con" v-for="(item,i) in guideList" :key="i" @click="guide_text(item)">
							<div class="img">
								<img :src="item.cover?global.oss_link +item.cover:''">
							</div>
        		            <div class="trends_txt">
        		                <div class="yuan">{{item.title}}</div>
        		                <div class="sub_title">{{item.sub_title}}</div>
        		                <div class="time">{{item.release_time}}</div>
								<img class="blue_line" :src='global.oss_website+"/pc/images/dyy_img/blue_line.png"' alt="">
        		            </div>
        		        </div>
        		    </div>
                </div>
        	    <div class="nodata" v-else>
			    	<img style="width: 500px;" :src="global.oss_website+'/wap/images/no_data_img.jpg'">
			    	<p>暂时没有找到你要的通知<span v-if="empty_bol"><span>，</span><el-link v-if="empty_bol" type="primary" :underline="false" @click="empty()">点击返回</el-link></span></p>
			    </div>

        	</div>
			<div class="paging" v-if="total!=0">
				<el-pagination
				  background
    			  @size-change="handleSizeChange"
    			  @current-change="handleCurrentChange"
    			  :current-page="params.page"
    			  :page-sizes="[10, 20, 30, 40]"
    			  :page-size="params.limit"
    			  layout="prev, pager, next"
    			  :total="total">
    			</el-pagination>
			</div>
		</div>
		<div v-else>
			<div class="current_location">
				<span>当前位置</span> >
				<span style="cursor: pointer;" @click="page = 'list'">通知公告</span> >
				<span style="color: #008dfc;">{{current_location_title}}</span>
			</div>
			<guidetextassembly :news_id="news_id" :not_login="true"></guidetextassembly>
		</div>
		
	</div>
</template>

<script>
import guidetextassembly from '@/components/dyy_assembly/guideTextAssembly.vue'
export default {
	props:['switch_jump'],
	name: 'material'
	,data () {
		return {
            guideList:[],
			loading:false,
			// currentPage4:1,
			params:{
				page:1,
				limit :10,
                title:''
			},
			total:0,
            empty_bol:false,
			// tag_list:[],		//标签列表
			tag_id:0,
            search_tim_obj:'',
			page:'list',
			news_id:'',
			current_location_title:''
		}
	}
	,mounted:function(){
		// console.log(this.$route.query.page);
		this.getguide(true,true)
	}
	,components:{
        guidetextassembly
    }
	,watch:{
		total(){

		}
	}
	,computed:{

	}
	,methods:{
		// pageSize 改变时会触发
		handleSizeChange(data){
			// console.log(111);
			// console.log(data);
			this.params.limit  = data
			this.getguide()
		},
		// currentPage 改变时会触发
		handleCurrentChange(data){
			// console.log(222);
			// console.log(data);
			this.params.page = data
			this.getguide()
		},
        search_tim_fn(){
            let that = this
            if (this.search_tim_obj) {
                clearTimeout(this.search_tim_obj)        
            }
            this.search_tim_obj = setTimeout(function(){
                that.getguide(true)
            },1000)
        },
		// 跳转
		guide_text(data){
			this.current_location_title = data.title
			if (this.switch_jump) {
				this.news_id = data.id
				this.page = 'text'
			}else{
				this.$router.push({
					name:'guide_text',
					query:{
						id:data.id,
						page:this.$route.query.page
					}
				});
			}
			
            
		},
		//返回
        return_fn(){
			this.page = 'list'
        },
		//列表
		async getguide(bol,empty){
            if (bol) {
                this.params.page = 1
            }
            if (!empty) {
                this.empty_bol = true
            }
			this.loading = true
			// console.log(this.$store.state.grade_id);
			let serverSrc=this.global.serverSrc
			,qianzui=this.global.qianzui;
			await this.$ajax.get(serverSrc + qianzui + "/news/index_news_list",{params:this.params})
			.then((res)=>{
				this.guideList = res.data.data.data
				this.total = res.data.data.total
				this.loading = false
				// console.log(res);
				// console.log(res.list.data);
			})
			.catch(_ => {
				that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~');
			});
		},
        //返回清空
        empty(){
            this.params.title = ''
            this.params.page = 1
            this.getguide()
        },

	}
	,destroyed:function(){
		window.removeEventListener('scroll',this.getScrollPosition,false)
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/dyy_assembly/announcement.vue